import { type SerializedPageStructure } from '@wix/document-services-types'

import { modifyComponentByVeloId } from '../utils'
import { FIELD_STACK_VELO_ID } from './veloIds'

export const removeFieldTemplates = (page: SerializedPageStructure) =>
  modifyComponentByVeloId({
    root: page,
    veloId: FIELD_STACK_VELO_ID,
    modifyComponent: fieldStack => ({ ...fieldStack, components: [] }),
  })
